import * as mutationTypes from './mutation-types'
import api from '@/store/api/metric'
import {find} from 'lodash'

const initialState = () => ({
    charts: [],
    selected: null,
    metrics: [],
    metricTypes: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        metric: state => find(state.metrics, {id: state.selected}),
        metrics: state => state.metrics,
        metricTypes: state => state.metricTypes,
        charts: state => state.charts
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listMetrics: async ({commit, dispatch}, params) => {
            try {
                const {data} = await api.listMetrics(params)
                commit(mutationTypes.SET_METRICS, data)
                return data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listCharts: async ({commit, dispatch}, params) => {
            try {
                const {data} = await api.listCharts(params)
                commit(mutationTypes.SET_CHARTS, data)
                return data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listMetricTypes: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listTypes(params)
                commit(mutationTypes.SET_METRIC_TYPES, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        selectMetric: async ({commit}, id) => commit(mutationTypes.SET_METRIC, id),
        resetMetric: async ({commit}, id) => commit(mutationTypes.RESET_METRIC, id),
        resetMetrics: ({commit}) => commit(mutationTypes.RESET_METRICS),
        resetCharts: ({commit}) => commit(mutationTypes.RESET_CHARTS),
        resetMetricTypes: ({commit}) => commit(mutationTypes.RESET_METRIC_TYPES)
    },
    mutations: {
        [mutationTypes.RESET_METRICS]: (state) => state.metrics = initialState().metrics,
        [mutationTypes.RESET_METRIC_TYPES]: (state) => state.metricTypes = initialState().metricTypes,
        [mutationTypes.RESET_CHARTS]: (state) => state.charts = initialState().charts,
        [mutationTypes.RESET_METRIC]: (state) => state.selected = null,
        [mutationTypes.SET_METRIC]: (state, id) => state.selected = id,
        [mutationTypes.SET_METRICS]: (state, data) => state.metrics = data,
        [mutationTypes.SET_METRIC_TYPES]: (state, data) => state.metricTypes = data,
        [mutationTypes.SET_CHARTS]: (state, data) => state.charts = data
    }
}
